// import React, { useEffect, useState } from 'react'
// import { Container, Row, Col, Card, FloatingLabel, Form, Button } from 'react-bootstrap'
// import { AuthService } from '../../Services/authServices';
// import Auth from '../../Auth/auth';
// import { useNavigate } from 'react-router-dom';
// import { toast } from 'react-toastify';

// export default function Login() {
//     const [loginData, setLoginData] = useState<any>({
//         email: "",
//         password: "",
//     });

//     const onChangeValue = (e: any) => {
//         setLoginData({ ...loginData, [e.target.name]: e.target.value });
//     };
//     const navigate = useNavigate();

//     const loginSubmit = async (e: any) => {
//         e.preventDefault();
//         await AuthService.login(({
//             email: loginData.email,
//             password: loginData.password
//         }))
//             .then(async (res) => {
//                 if (res.status === 200) {
//                     await Auth.authenticate();
//                     localStorage.setItem("authKey", res.data.token)
//                     navigate('/admin-dash/exam')
//                     toast("Login Success")
//                 }
//             })
//             .catch((err) => {
//                 if (err.response.status === 403) {
//                     console.error(err);
//                 } else if (err.response.status === 500) {
//                     alert(err.response.data)
//                 }
//             })
//     };

//     return (
//         <>
//             <Container>
//                 <h1 className="text-center font-weight-bold xcn-login-header">
//                     Admin Login
//                 </h1>
//                 <Row className="justify-content-md-center  mt-4">
//                     <Col xs lg="2" />
//                     <Col md="auto">
//                         <Card className="p-3" style={{ maxWidth: "25rem", minWidth: "25vw" }}>
//                             <>
//                                 <FloatingLabel
//                                     controlId="floatingInput"
//                                     label="Email address"
//                                     className="mb-3"
//                                 >
//                                     <Form.Control
//                                         type="email"
//                                         placeholder="name@example.com"
//                                         name="email"
//                                         onChange={onChangeValue}
//                                     />
//                                 </FloatingLabel>
//                                 <FloatingLabel
//                                     controlId="floatingPassword"
//                                     label="Password"
//                                     onChange={onChangeValue}
//                                 >
//                                     <Form.Control type="password" placeholder="Password" name="password" />
//                                 </FloatingLabel>
//                             </>
//                             <Button
//                                 variant="primary"
//                                 type="submit"
//                                 className="mt-4"
//                                 size="lg"
//                                 onClick={loginSubmit}
//                             >
//                                 <span className="xcn-text-14">
//                                     Login
//                                 </span>
//                             </Button>
//                         </Card>
//                     </Col>
//                     <Col xs lg="2" />
//                 </Row>
//             </Container>
//         </>
//     )
// }

import React, { useState } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  FloatingLabel,
  Form,
  Button,
} from "react-bootstrap";
import { AuthService } from "../../Services/authServices";
import Auth from "../../Auth/auth";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

export default function Login() {
  const [loginData, setLoginData] = useState<any>({
    email: "",
    password: "",
  });

  const navigate = useNavigate();

  const onChangeValue = (e: any) => {
    setLoginData({ ...loginData, [e.target.name]: e.target.value });
  };

  const loginSubmit = async (e: any) => {
    e.preventDefault();

    await AuthService.login({
      email: loginData.email,
      password: loginData.password,
    })
      .then(async (res) => {
        if (res.status === 200) {
          await Auth.authenticate();
          localStorage.setItem("authKey", res.data.token);
          navigate("/admin-dash/exam");
          toast("Login Success");
        }
      })
      .catch((err) => {
        if (err.response.status === 403) {
          console.error(err);
        } else if (err.response.status === 500) {
          alert(err.response.data);
        }
      });
  };

  return (
    <>
      <div style={{ height: "100vh", overflow: "hidden" }}>
        <Row className="h-100 g-0">
          {/* LEFT SIDE */}
          <Col
            md={6}
            className="d-none d-md-flex"
            style={{
              background: "#1f2937",
              color: "white",
              alignItems: "center",
              justifyContent: "center",
              flexDirection: "column",
              textAlign: "center",
              padding: "40px",
            }}
          >
            <h2 style={{ fontWeight: 700, letterSpacing: "0.5px" }}>
              Admin Login
            </h2>

            <p style={{ opacity: 0.75, maxWidth: "360px", marginTop: "12px" }}>
              Secure admin portal to manage examinations, users and system
              operations with full control and reliability.
            </p>
          </Col>

          {/* RIGHT SIDE */}
          <Col
            md={6}
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              background: "#f3f4f6",
            }}
          >
            <Container style={{ maxWidth: "380px" }}>
              <Card
                className="p-4 border-0 login-card"
                style={{
                  borderRadius: "14px",
                  background: "#ffffff",
                  boxShadow: "0 12px 28px rgba(0,0,0,0.08)",
                  transition: "all 0.3s ease",
                }}
              >
                <h4 className="text-center mb-4" style={{ fontWeight: 600 }}>
                  Sign In
                </h4>

                <FloatingLabel
                  controlId="floatingInput"
                  label="User Name"
                  className="mb-3"
                >
                  <Form.Control
                    type="email"
                    placeholder="name@example.com"
                    name="email"
                    onChange={onChangeValue}
                    className="input-modern"
                  />
                </FloatingLabel>

                <FloatingLabel
                  controlId="floatingPassword"
                  label="Password"
                  className="mb-3"
                >
                  <Form.Control
                    type="password"
                    placeholder="Password"
                    name="password"
                    onChange={onChangeValue}
                    className="input-modern"
                  />
                </FloatingLabel>

                <Form.Check
                  type="checkbox"
                  label="Remember me"
                  className="mb-3"
                />

                <Button
                  type="submit"
                  size="lg"
                  onClick={loginSubmit}
                  className="login-btn"
                >
                  Login
                </Button>
              </Card>
            </Container>
          </Col>
        </Row>
      </div>

      {/* Styles */}
      <style>
        {`
                .login-card:hover{
                    transform: translateY(-6px);
                    box-shadow: 0 22px 45px rgba(0,0,0,0.12);
                }

                .input-modern{
                    border-radius:8px !important;
                    border:1px solid #e5e7eb !important;
                    transition:all 0.2s ease;
                }

                .input-modern:focus{
                    border-color:#4f46e5 !important;
                    box-shadow:0 0 0 3px rgba(79,70,229,0.15) !important;
                }

                .login-btn{
                    background:#111827 !important;
                    border:none !important;
                    border-radius:8px !important;
                    height:45px;
                    font-weight:600;
                    transition:all 0.25s ease;
                }

                .login-btn:hover{
                    background:#000 !important;
                    transform:translateY(-2px);
                    box-shadow:0 10px 20px rgba(0,0,0,0.2);
                }
                `}
      </style>
    </>
  );
}
